<div class="dialog-container">
  <div class="title">
    <mat-icon>mail</mat-icon>
    <span>Share Document by Email</span>
  </div>
  @if (emailBoxField && emailBoxFieldControl) {
    <div class="content">
      <cotecna-email-box
        [field]="emailBoxField"
        [control]="emailBoxFieldControl"
        (fieldChange)="onEmailAdded($event)"
      >
      </cotecna-email-box>
    </div>
  }
  <div class="actions">
    <button id="cancel-send-document" (click)="cancel()" mat-button>
      CANCEL
    </button>
    <button
      id="send-document"
      [disabled]="emailsToSend?.length === 0"
      (click)="sendDocument()"
      mat-button
      color="primary"
    >
      SEND
    </button>
  </div>
</div>
